import styles from "./FilterButton.module.css";
import exitIcon from "../../../../../assets/x-highlight.png";

export default function FilterButton({
  filters,
  setFilters,
  filter,
  setShowOptions,
}) {
  const showOptionsHandler = () => {
    setShowOptions((prevState) => !prevState);
  };

  const cancelAllFilters = () => {
    setFilters([]);
  };

  return (
    <main className={styles[`filter-container`]}>
      <div
        className={`${styles[`filter`]} ${
          styles[filters.length > 0 && `filter-active`]
        }`}
        onClick={showOptionsHandler}
      >
        {filter}
      </div>
      <div
        className={`${styles.cancel} ${
          styles[filters.length > 0 && `cancel-active`]
        }`}
        onClick={cancelAllFilters}
      >
        <img src={exitIcon} alt="x" className={styles[`exit-icon`]} />
        Poništi sve
      </div>
    </main>
  );
}
